import { FONT_SIZE, FONT_WEIGHT, Icon, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivRootContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ParContentsHead = styled.div`
  font-size: ${FONT_SIZE.S}px;
  margin-right: 3px;
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const ParContentsValue = styled.div`
  display: flex;
  align-items: center;
  font-size: ${FONT_SIZE.S}px;
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const PointIcon = styled(Icon)`
  margin-right: 3px;
  & svg {
    width: 16px;
    height: 16px;
  }
`;

export const PointValue = styled.div`
  margin-right: 3px;
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: ${FONT_SIZE.S}px;
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;
